import { Box, Divider, HStack, Skeleton } from "@chakra-ui/react";

export const RichTextEditorSkeleton = () => (
    <Box>
        <Box minHeight="200px" height={["calc(100dvh - 290px)", "auto"]}>
            <Skeleton w="200px" h={3} />
        </Box>
        <Divider my={2} />
        <HStack justifyContent="space-between" alignItems="flex-start" pb={2}>
            <Skeleton w="176px" h={4} />
            <Skeleton w={4} h={4} />
        </HStack>
    </Box>
);
